import { isPermissionError, extractPermissionErrorMessage } from "../constants/errorCodes";
import Swal from 'sweetalert2';

/**
 * 권한 에러 처리 핸들러
 * @param {Array} errors - GraphQL 에러 배열
 * @returns {Promise<boolean>} - 권한 에러가 처리되었으면 true, 아니면 false
 */
export const handlePermissionErrors = async (errors) => {
  if (!errors || !Array.isArray(errors)) {
    return false;
  }

  const permissionErrors = errors.filter(error => 
    isPermissionError(error.extensions?.errorType)
  );
  
  if (permissionErrors.length > 0) {
    // 권한 에러가 있으면 사용자에게 알림 표시
    const permissionError = permissionErrors[0];
    const message = extractPermissionErrorMessage(permissionError);
    
    await Swal.fire({
      icon: 'warning',
      title: '접근 권한 없음',
      text: message,
      confirmButtonText: '확인'
    });
    
    return true; // 권한 에러 처리됨
  }
  
  return false; // 권한 에러 없음
}; 